import { render, staticRenderFns } from "./CreateTaxCodePopUp.vue?vue&type=template&id=66f95bcb&scoped=true&"
import script from "./CreateTaxCodePopUp.vue?vue&type=script&lang=js&"
export * from "./CreateTaxCodePopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateTaxCodePopUp.vue?vue&type=style&index=0&id=66f95bcb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f95bcb",
  null
  
)

export default component.exports